import React from "react";
import { useTheme } from "../../hooks/ThemeContext";
import { Moon, Sun } from "lucide-react";

const ThemeToggleButton = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex items-center justify-between  px-1 bg-background-secondary rounded-lg h-[2.8rem] w-[5.5rem]">
      <div
        className={`cursor-pointer p-2 ${
          theme === "dark" && "bg-background  rounded-lg"
        } `}
        onClick={theme === "light" ? toggleTheme : null}
      >
        <Moon color="var(--baseColor)" size={20} />
      </div>
      <div
        className={`cursor-pointer p-2 ${
          theme === "light" && "bg-background  rounded-lg"
        } `}
        onClick={theme === "dark" ? toggleTheme : null}
      >
        <Sun color="var(--baseColor)" fill="var(--baseColor)" size={20} />
      </div>
    </div>
  );
};

export default ThemeToggleButton;
